<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
</svg>
